import { useSelector } from "react-redux";

export default function useGetTourneyRegDeRegLoadingState() {
  let loadingState = useSelector(
    (state) => state?.lobby?.showTourneyRegisterOrDeregisterRequestLoading
  );
  return loadingState;
}
